// extracted by mini-css-extract-plugin
module.exports = {"categories__wrapper":"M_cX","categories__list":"M_cY"};